import { SEC_TYPE } from 'const/stock'
import { fetchFutBrief, fetchFutContract } from 'apis/fut'

/**
 * 期货过期状态
 * @param {object} fut
 * @returns {string}
 */
function futExpiryStatus(fut) {
  let expiryStatus = 'online'
  const curTime = new Date().valueOf() / 1000
  const firstime = fut.firstNoticeDateTimestamp
  const lastime = fut.lastTradingDateTimestamp
  const firsSecondTime = firstime / 1000
  const lastSecondTime = lastime / 1000
  const firstPre7 = firsSecondTime - 7 * 24 * 3600
  const lastPre7 = lastSecondTime - 7 * 24 * 3600
  if (firstime === 0 && lastime === 0) expiryStatus = 'online'
  else if (firstime === 0) {
    if (curTime < lastPre7) expiryStatus = 'online'
    else if (curTime < lastSecondTime) expiryStatus = 'expiry'
    // 过期未下架，显示下架
    else expiryStatus = 'expiry' // 下架
  } else if (firsSecondTime >= lastSecondTime) {
    if (curTime < lastPre7) expiryStatus = 'online'
    else if (curTime < lastSecondTime) expiryStatus = 'expiry'
    // 过期未下架，显示下架
    else if (lastSecondTime === 0) expiryStatus = 'online'
    else expiryStatus = 'expiry' // 下架
  } else {
    if (curTime < firstPre7) expiryStatus = 'online'
    else if (curTime < firsSecondTime) expiryStatus = 'willExpiry'
    // 将过期
    else if (curTime < lastPre7) expiryStatus = 'expiry'
    // 将下架
    else if (curTime < lastSecondTime) expiryStatus = 'expiry'
    // 将下架
    else if (lastSecondTime === 0) expiryStatus = 'online'
    else expiryStatus = 'expiry' // 下架
  }
  return expiryStatus
}
const actions = {
  async getMultiFutList({ dispatch, getters }, stocks) {
    const symbols = []
    stocks.forEach(item => {
      if (item.secType !== SEC_TYPE.FUT) return
      symbols.push(item.symbol)
    })
    if (!symbols.length) return stocks
    const { data: respData } = await fetchFutContract({
      contractCodes: symbols,
      lang: getters.languageServerNeed
    })
    if (!respData) return
    respData.data.map(item => {
      const target = stocks.find(stock => {
        return stock.symbol === item.contractCode
      })
      if (target) {
        target.futContent = item
      }
    })
    await dispatch('getFutDetail', { stocks, symbols })
    return stocks
  },
  async getFutDetail({ commit }, { stocks, symbols }) {
    const res = await fetchFutBrief(symbols)
    if (!res.data) return
    const respData = res.body.data.items
    respData.map(item => {
      const target = stocks.find(stock => {
        return stock.symbol === item.contractCode
      })
      if (!target) return
      target.change = item.lastPrice - item.preClose
      target.preClose = item.preClose
      target.latestPrice = item.lastPrice
      if (target.futContent) Object.assign(target.futContent, item)
      else target.futContent = item
    })
    return stocks
  },
  getExpStatus({ dispatch, getters }, stocks) {
    stocks.forEach(stock => {
      if (stock.futContent && stock.futContent.securityType === SEC_TYPE.FUT) {
        stock.expOrOffline = futExpiryStatus(stock.futContent)
      }
    })
    return stocks
  }
}

export default { actions }
